// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Carousel_paginationContainer__8fFhQ"};